<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('string.changeBorrowerId') }}
          </h3>
        </div>
        <div class="box-body">
          <div class="form-horizontal">
            <template v-if="client !== null">
              <div class="form-group row">
                <label class="col-sm-3 control-label required">{{ $t('label.name') }}</label>
                <div class="col-sm-9">
                  {{ client.name }} {{ client.last_name }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 control-label required">{{ $t('label.oldBorrowerId') }}</label>
                <div class="col-sm-9">
                  {{ client.search_borrower_id }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 control-label required">{{ $t('label.email') }}</label>
                <div class="col-sm-9">
                  {{ client.email || 'N/A' }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 control-label required">{{ $t('label.phone') }}</label>
                <div class="col-sm-9">
                  {{ client.phone || 'N/A' }}
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 control-label required">{{ $t('label.linkWithLoanDiskBorrowerId') }}</label>
                <div class="col-sm-9">
                  {{ client.loan_disk_borrower_id || 'N/A' }}
                </div>
              </div>
            </template>
            <div :class="'form-group row ' + (validations !== null && validations.hasOwnProperty('borrowUser') ? 'has-error' : '')">
              <label class="col-sm-3 control-label">{{ $t('label.user') }}</label>
              <div class="col-sm-9">
                <multiselect
                  v-model="user"
                  tracky="id"
                  label="name"
                  :options="users"
                  @search-change="getUsers"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  :deselect-label="$t('string.press_enter_to_remove')"
                  :select-label="$t('string.press_enter_to_select')"
                  :selected-label="$t('string.multiple_select_selected')"
                  :placeholder="$t('string.selectUser')"
                >
                  <template slot="noOptions">
                    {{ $t('string.empty') }}
                  </template>
                  <template slot="noResult">
                    {{ $t('string.noResult') }}
                  </template>
                </multiselect>
                <span
                  class="label-error"
                  v-if="validations !== null && validations.hasOwnProperty('borrowUser')"
                >
                  {{ validations['borrowUser'][0] }}
                </span>
              </div>
            </div>
            <div
              :class="'form-group row ' + (validations !== null && validations.hasOwnProperty('new_borrower_id') ? 'has-error' : '')"
            >
              <label class="col-sm-3 control-label required">{{ $t('label.borrowerId') }}</label>
              <div class="col-sm-9">
                <input
                  type="number"
                  v-model="new_borrower_id"
                  :placeholder="$t('label.borrowerId')"
                  class="form-control"
                  name="borrower_id"
                >
                <span
                  class="label-error"
                  v-if="validations !== null && validations.hasOwnProperty('new_borrower_id')"
                >
                  {{ validations['new_borrower_id'][0] }}
                </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-offset-3 col-sm-9">
                <button
                  class="btn btn-primary btn-sm margin-right-5"
                  @click="changeBorrowerID"
                >
                  <i class="fa fa-key" /> {{ $t('button.changeBorrowerId') }}
                </button>
                <button
                  class="btn btn-default btn-sm"
                  @click="$router.push({name: 'list-client'})"
                >
                  {{ $t('button.back') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce'

export default {
  name: 'ChangeBorrowerId',
  metaInfo () {
    return {
      title: this.$t('string.changeBorrowerId'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      client: null,
      new_borrower_id: '',
      validations: null,
      user: null,
      users: []
    }
  },
  methods: {
    getClient () {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/client/show', {
        borrow_id: this.$route.params.borrow_id
      }).then((response) => {
        if (response.data.code === 1) {
          this.client = response.data.data
          if (this.client.user) {
            const user = this.client.user
            this.user = {
              id: user.id,
              name: `${user.name} (${user.phone})`
            }
          } else {
            this.user = null
          }
          if (this.client.borrower_id) {
            this.new_borrower_id = this.client.borrower_id
          }
        }
      })
    },
    getUsers: debounce(function (query_text) {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/remote-users-option', {
        query_text: query_text
      }).then((response) => {
        if (response.data.code === 1) {
          this.users = response.data.data
        }
      })
    }, 300),
    changeBorrowerID () {
      this.validations = null
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/change-borrower-id', {
        borrow_id: this.$route.params.borrow_id,
        new_borrower_id: this.new_borrower_id,
        borrowUser: this.user
      }).then((response) => {
        if (response.data.code === 1) {
          this.$router.push({ name: 'list-client' })
          this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
        } else {
          if (typeof (response.data.message) === 'string') {
            this.$toastr('error', response.data.message, this.$t('string.error'))
          } else {
            this.validations = response.data.message
          }
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    }
  },
  created () {
    this.getClient()
    this.getUsers()
  }
}
</script>

<style scoped>

</style>
